import React, { useState } from "react";
import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from "@mui/material/Grid";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import PhoneInput from "react-phone-number-input";
import { useNavigate } from "react-router-dom";

import "./style.css";

export default function NewInquiry() {
  const navigate = useNavigate();

  const [sources] = useState([
    "Instagram/Facebook Ads",
    "Google Ads (LiveChat)",
    "Google Ads (WhatsApp)",
    "Partner",
    "Kenalan",
    "Ga Tau",
    "OLX",
  ]);

  const [produkOptions] = useState([
    "Virtual Office",
    "Private Office",
    "Meeting Room Kecil",
    "Meeting Room Besar (Event Room)",
    "Pendirian PT",
    "Pendirian CV",
    "Izin Khusus",
    "PKP",
    "Pajak",
    "Akutansi",
    "Website",
    "Merek",
  ]);

  const [lokasiOptions] = useState([
    "Jakarta Selatan",
    "Jakarta Barat",
    "Jakarta Pusat",
    "Jakarta Utara",
    "Jakarta Timur",
    "Tangerang",
    "Bekasi",
    "Bali",
    "Surabaya",
    "Depok",
    "Kalimantan",
  ]);

  const [salesOptions] = useState(["Diva", "Dinda"]);

  const [selectedSources, setSelectedSources] = useState([]);
  const [selectedLokasi, setSelectedLokasi] = useState([]);
  const [selectedProduk, setSelectedProduk] = useState([]);
  const [salesMode, setSalesMode] = useState("system");
  const [manualSales, setManualSales] = useState("");
  const [inqDate, setInqDate] = useState(new Date());
  const [namaKlien, setNamaKlien] = useState("");
  const [notes, setNotes] = useState("");
  const [adCode, setAdCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const endpoint = `${process.env.REACT_APP_BACKEND_URL}/manualNewInquiryHandling`;

  const handleBDateChange = (date) => {
    setInqDate(date);
  };

  const buildPayload = () => {
    const sourceText =
      selectedSources && selectedSources.length > 0
        ? selectedSources.join(", ")
        : "Manual Input Dashboard";

    const produkText =
      selectedProduk && selectedProduk.length > 0
        ? selectedProduk.join(", ")
        : "";

    const lokasiText =
      selectedLokasi && selectedLokasi.length > 0
        ? selectedLokasi.join(", ")
        : "";

    const cleanedAdCode = String(adCode || "").trim();

    const messageSummary = [
      "Manual inquiry dari dashboard",
      namaKlien ? `Nama: ${namaKlien}` : "",
      phoneNumber ? `Phone: ${phoneNumber}` : "",
      sourceText ? `Dari: ${sourceText}` : "",
      produkText ? `Produk: ${produkText}` : "",
      lokasiText ? `Lokasi: ${lokasiText}` : "",
      cleanedAdCode ? `AdCode: ${cleanedAdCode}` : "",
      salesMode === "manual" && manualSales
        ? `Manual sales: ${manualSales}`
        : "Sales: randomize by system",
      notes ? `Notes: ${notes}` : "",
    ]
      .filter(Boolean)
      .join(" | ");

    const noteHistory = [
      "Input manual dari dashboard",
      salesMode === "manual" && manualSales
        ? `Sales manual ${manualSales}`
        : "Sales by system",
      notes ? notes.trim() : "",
    ]
      .filter(Boolean)
      .join(" - ");

    return {
      Nama: namaKlien || "",
      Messege: messageSummary || "Manual inquiry dari dashboard",
      "Date and Time": inqDate
        ? new Date(inqDate).toISOString()
        : new Date().toISOString(),
      "Phone Number": phoneNumber || "",
      Phone: phoneNumber || "",
      From: sourceText,
      conversation_id: `manual-${Date.now()}`,
      Produk_Interest: produkText,
      Lokasi_interest: lokasiText,
      First_message: notes || "",
      notehistory: noteHistory || "Input manual dari dashboard",
      actorId: "manual_dashboard",
      channel: "whatsapp",
      needs: "",
      salesMode,
      manualSales: salesMode === "manual" ? manualSales : "",
      adcode: cleanedAdCode,
    };
  };

  const saveInquiry = async () => {
    setError("");

    if (!phoneNumber || String(phoneNumber).trim() === "") {
      setError("Nomor telepon wajib diisi");
      return;
    }

    if (salesMode === "manual" && !manualSales) {
      setError("Pilih sales terlebih dahulu jika mode Manual Sales");
      return;
    }

    try {
      setLoading(true);

      const payload = buildPayload();

      await axios.post(endpoint, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      navigate("/listinquiry");
    } catch (err) {
      console.error("saveInquiry error:", err);

      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Gagal simpan inquiry";

      const step = err?.response?.data?.step
        ? ` (step: ${err.response.data.step})`
        : "";

      setError(`${backendMessage}${step}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container>
      <Grid item xl={0.5} lg={1.9} md={2.6} sm={3.2} className="leftmenucolor">
        <LeftMenu />
      </Grid>

      <Grid item xl={11.5} lg={10.1} md={9.4} sm={8.8}>
        <Grid className="boxshadowclass">
          <Header />
        </Grid>

        <Grid sx={{ p: 5 }}>
          <Grid container sx={{ mt: 2 }}>
            <Grid item sm={2}>
              Nomor Telepon*:
            </Grid>
            <Grid item sm={7}>
              <PhoneInput
                international
                defaultCountry="ID"
                value={phoneNumber}
                placeholder="Nomor Telepon"
                onChange={setPhoneNumber}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              Dari:
            </Grid>
            <Grid item sm={10}>
              <Autocomplete
                sx={{ width: 360 }}
                multiple
                options={sources}
                freeSolo
                getOptionLabel={(option) => option}
                disableCloseOnSelect
                value={selectedSources}
                onChange={(event, newValue) => {
                  setSelectedSources(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Pilih Sumber"
                    placeholder="Pilih Sumber"
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <MenuItem
                    {...props}
                    key={option}
                    value={option}
                    sx={{ justifyContent: "space-between" }}
                  >
                    {option}
                    {selected ? <CheckIcon color="info" /> : null}
                  </MenuItem>
                )}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              Sales Mode*:
            </Grid>
            <Grid item sm={7}>
              <Select
                fullWidth
                value={salesMode}
                onChange={(event) => {
                  setSalesMode(event.target.value);
                  if (event.target.value !== "manual") {
                    setManualSales("");
                  }
                }}
              >
                <MenuItem value="system">Randomize by system</MenuItem>
                <MenuItem value="manual">Manual Sales</MenuItem>
              </Select>
            </Grid>
          </Grid>

          {salesMode === "manual" && (
            <Grid container sx={{ mt: 5 }}>
              <Grid item sm={2}>
                Pilih Sales*:
              </Grid>
              <Grid item sm={7}>
                <Select
                  fullWidth
                  value={manualSales}
                  onChange={(event) => setManualSales(event.target.value)}
                  displayEmpty
                >
                  <MenuItem value="">Pilih Sales</MenuItem>
                  {salesOptions.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          )}

          {salesMode === "system" && (
            <Grid container sx={{ mt: 5 }}>
              <Grid item sm={2}>
                Sales:
              </Grid>
              <Grid item sm={7}>
                Akan dipilih otomatis oleh backend ke <b>deal.Sales</b>
              </Grid>
            </Grid>
          )}

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              Nama Klien:
            </Grid>
            <Grid item sm={7}>
              <TextField
                fullWidth
                value={namaKlien}
                onChange={(event) => setNamaKlien(event.target.value)}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              <p>Tanggal:</p>
            </Grid>
            <Grid item sm={7}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  views={["year", "month", "day"]}
                  inputFormat="dd/MM/yyyy"
                  value={inqDate}
                  onChange={handleBDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarMonthIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              Interest Produk:
            </Grid>
            <Grid item sm={7}>
              <Autocomplete
                sx={{ width: 360 }}
                options={produkOptions}
                freeSolo
                multiple
                getOptionLabel={(option) => option}
                disableCloseOnSelect
                value={selectedProduk}
                onChange={(event, newValue) => {
                  setSelectedProduk(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Pilih Produk"
                    placeholder="Pilih Produk"
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <MenuItem
                    {...props}
                    key={option}
                    value={option}
                    sx={{ justifyContent: "space-between" }}
                  >
                    {option}
                    {selected ? <CheckIcon color="info" /> : null}
                  </MenuItem>
                )}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              Interest Lokasi:
            </Grid>
            <Grid item sm={7}>
              <Autocomplete
                sx={{ width: 360 }}
                options={lokasiOptions}
                freeSolo
                multiple
                getOptionLabel={(option) => option}
                disableCloseOnSelect
                value={selectedLokasi}
                onChange={(event, newValue) => {
                  setSelectedLokasi(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Pilih Lokasi"
                    placeholder="Pilih Lokasi"
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <MenuItem
                    {...props}
                    key={option}
                    value={option}
                    sx={{ justifyContent: "space-between" }}
                  >
                    {option}
                    {selected ? <CheckIcon color="info" /> : null}
                  </MenuItem>
                )}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              AdCode:
            </Grid>
            <Grid item sm={7}>
              <TextField
                fullWidth
                value={adCode}
                onChange={(event) => setAdCode(event.target.value)}
                placeholder="Optional"
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            <Grid item sm={2}>
              Notes:
            </Grid>
            <Grid item sm={7}>
              <TextareaAutosize
                style={{ minHeight: "200px", width: "100%" }}
                value={notes}
                onChange={(event) => setNotes(event.target.value)}
              />
            </Grid>
          </Grid>

          {error && (
            <Grid className="error_text" sx={{ mb: 3, mt: 3 }}>
              {error}
            </Grid>
          )}

          <Button
            variant="contained"
            color="success"
            onClick={saveInquiry}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Inquiry"}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}